import { createFileRoute } from "@tanstack/react-router";
import { useAppForm } from "@/components/form-inputs";
import { Main } from "@/layout/main";

export const Route = createFileRoute("/_authenticated/utils/form")({
  component: RouteComponent,
});

function RouteComponent() {
  const form = useAppForm({
    defaultValues: {
      name: "ahmed",
      age: 13,
      isMarried: false,
      birthdate: new Date(),
      cars: [] as string[],
      items: [] as string[],
      checkBoxes: [] as string[],
      image: new File([], "placeholder.jpg"),
      location: null,
      editorData: "",
    },
  });

  const onSubmitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    form.handleSubmit();
  };

  const testItems = [
    { value: "1", label: "One" },
    { value: "2", label: "Two" },
    { value: "3", label: "Three" },
  ];

  const checkboxOptions = ["Tesla", "Jeep", "Mercedes", "BMW", "Car", "Car2", "Car3", "Car4"];

  return (
    <Main>
      <form onSubmit={onSubmitHandler} className="flex flex-col gap-5">
        <form.AppField name="name">{(field) => <field.TextField label="Name" />}</form.AppField>

        <form.AppField name="age">{(field) => <field.NumberField label="Age" />}</form.AppField>

        <form.AppField name="isMarried">{(field) => <field.CheckboxField label="Is Married" />}</form.AppField>

        <form.AppField name="cars">
          {(field) => (
            <field.CheckboxGroupField label="Cards" options={checkboxOptions.map((o) => ({ value: o, label: o }))} />
          )}
        </form.AppField>

        <form.AppField name="items">
          {(field) => <field.DropdownField options={testItems} placeholder="select items..." />}
        </form.AppField>

        <form.Subscribe selector={(state) => state.values}>
          {(values) => <pre>{JSON.stringify(values, null, 2)}</pre>}
        </form.Subscribe>

        {/* <form.AppField name="editorData">{(field) => <field.EditorField />}</form.AppField> */}

        {/* <form.AppField name="location">{(field) => <field.LocationField />}</form.AppField> */}

        <form.AppForm>
          <form.SubmitButton>Submit</form.SubmitButton>
        </form.AppForm>
      </form>
    </Main>
  );
}
